import sortArrayByProperty from './array/sortArrayByProperty';
import countries from './countries';

export default async () => {
  try {
    const formattedCountries = countries.reduce(
      (acc, country) => [
        ...acc,
        {
          ...country,
          label: country.translations?.[navigator.language] ?? country.name,
          value: country.alpha2Code,
          flag: country.flag,
        },
      ],
      [],
    );

    const sortedCountries = sortArrayByProperty(
      formattedCountries.filter(country => country?.position),
      'position',
    );

    const unsortedCountries = sortArrayByProperty(
      formattedCountries.filter(country => !country?.position),
      'label',
    );

    return [...sortedCountries, ...unsortedCountries];
  } catch (error) {
    return Promise.reject(error);
  }
};
